// src/components/layout/AppLayout.js
import React from 'react';
import Navbar from './Navbar';
import { Link } from 'react-router-dom';

const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      <main className="min-h-[calc(100vh-64px)] pt-16">
        {children}
      </main>
    </div>
  );
};

export default AppLayout;